export const LG_BREAKPOINT = 992;

export default LG_BREAKPOINT;
